
import EoButton from '../../EoButton/EoButton.vue'

export default {
  name: "PreprButton",
  components: { EoButton },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  computed: {
    label () {
      return this.data.labelData?.body
    },
    to () {
      // Check if button refers to a direct url
      if (this.data.url?.body) return this.data.url.body

      // Check if button refers to a publication
      if (!this.data.reference?.items[0]) return null
      return this.$link.publication(this.data.reference.items[0])
    },
    target () {
      return this.to?.startsWith('http') ? '_blank' : '_self'
    },
  },
}
